module["exports"] = [
  "#{city_name}",
  "#{city_prefix} #{Name.male_first_name}"
];
